import * as types from './types';

export function setUserSource(userSource) {
  return {
    type: types.SET_USER_SOURCE,
    payload: { userSource },
  };
}
